import { ColumnDef } from "@tanstack/react-table";
import { useEffect, useState } from "react";
import api from "../../api/axios";
import { DataTable } from "../data-table/data-table";

export function Enrollments() {

    const [emailsRaw, setEmailsRaw] = useState('');

    const [course1, setCourse1] = useState<boolean>(true); // NEW Grundlagenschulung KI-Kompetenzen
    const [course2, setCourse2] = useState<boolean>(true); // NEW 9 Grundsätze für einen verantwortungsbewussten KI-Einsatz
    const [course3, setCourse3] = useState<boolean>(true); // NEW Microsoft Copilot
    const [course4, setCourse4] = useState<boolean>(true); // NEW Fundamentals Training in AI Competencies

    const [messages, setMessages] = useState<string[]>([]);

    const [loading, setLoading] = useState<boolean>(false);

    const enroll = async () => {
        setLoading(true);
        try {
            const response = await api.post('/enroll', {
                courses: {
                    course1, // NEW Grundlagenschulung KI-Kompetenzen
                    course2, // NEW 9 Grundsätze für einen verantwortungsbewussten KI-Einsatz
                    course3, // NEW Microsoft Copilot
                    course4  // NEW Fundamentals Training in AI Competencies
                },
                emails: getEmailsList()
            });

            if (response.status === 200) {
                alert("Enrollment was successful!");
                setCourse1(true);
                setCourse2(true);
                setCourse3(true);
                setCourse4(true);
                setMessages(response.data);
            } else {
                alert("Failed to enroll.");
            }
        } catch (error) {
            console.error("Error enrolling:", error);
            alert("An error occurred while enrolling.");
        } finally {
            setLoading(false);
        }
    }

    const getEmailsList = () => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        const emailsArray = emailsRaw
            .split(/[\n,]+/)
            .map(email => email.trim())
            .filter(email => email !== "" && emailRegex.test(email));

        return emailsArray;
    };

    return (
        <div className="enrollments">
            <div className="area">
                <h4>Kurse</h4>
                <div>
                    <input className="course-checkbox" type="checkbox" id="course1" checked={course1} onChange={(e) => setCourse1(e.target.checked)} />
                    <label htmlFor="course1">NEW Grundlagenschulung KI-Kompetenzen</label>
                </div>
                <div>
                    <input className="course-checkbox" type="checkbox" id="course2" checked={course2} onChange={(e) => setCourse2(e.target.checked)} />
                    <label htmlFor="course2">NEW 9 Grundsätze</label>
                </div>
                <div>
                    <input className="course-checkbox" type="checkbox" id="course3" checked={course3} onChange={(e) => setCourse3(e.target.checked)} />
                    <label htmlFor="course3">NEW Microsoft Copilot</label>
                </div>
                <div>
                    <input className="course-checkbox" type="checkbox" id="course4" checked={course4} onChange={(e) => setCourse4(e.target.checked)} />
                    <label htmlFor="course4">NEW Fundamentals Training in AI Competencies</label>
                </div>
            </div>
            <div className="area">
                <h4>E-Mails der Benutzer eingeben (Komma oder Zeilenumbruch getrennt)</h4>
                <textarea
                    placeholder="E-Mails der Benutzer eingeben (Komma oder Zeilenumbruch getrennt)"
                    value={emailsRaw}
                    onChange={(e) => setEmailsRaw(e.target.value)}
                />
            </div>
            <div className="area">
                <h4>Vorschau der E-Mails ({getEmailsList().length}):</h4>
                <div className="emails-list">
                    {getEmailsList().map((email, index) => (
                        <div key={index}>{email}</div>
                    ))}

                </div>
            </div>
            <div className="area">
                <button disabled={loading || getEmailsList().length === 0} style={{backgroundColor: ((loading || getEmailsList().length === 0) ? 'gray' : '')}} className="button button-primary" onClick={enroll}>Enrollen</button>
                {messages.length > 0 && (
                    <div className="enrollment-message">
                        {messages.map((msg, index) => (
                            <div key={index}>{msg}</div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}